import React, { useState } from 'react'
import { useTranslation } from '../hooks/use-i18n'
import roomsService from '../services/roomsService'
import { Room } from '../types/room'

interface EditFormula1RoomModalProps {
  roomName: string
  roomId: string
  onClose: () => void
  onSuccess: (room: Room) => void
}

const EditFormula1RoomModal: React.FC<EditFormula1RoomModalProps> = ({
  roomName,
  roomId,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation()
  const [name, setName] = useState(roomName)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim()) return
    setIsLoading(true)
    try {
      const updated = await roomsService.updateRoom(roomId, { name: name.trim() })
      onSuccess(updated)
    } catch (err: any) {
      console.error('Failed to update room:', err)
      // toast handled by caller or could add here
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="w-full max-w-md glass-strong rounded-xl p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-bold text-foreground mb-4">
          {t('room.editRoom')}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              {t('createRoom.roomName')}
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 rounded-xl bg-muted/10 border border-muted/20 text-foreground focus:outline-none focus:border-primary/50"
              placeholder={t('createRoom.placeholderRoomName')}
              autoFocus
            />
          </div>
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-xl font-medium bg-muted/20 text-foreground hover:bg-muted/30"
            >
              {t('common.cancel')}
            </button>
            <button
              type="submit"
              disabled={isLoading || !name.trim()}
              className="px-4 py-2 rounded-xl font-medium bg-primary text-primary-foreground hover:opacity-90 disabled:opacity-50"
            >
              {isLoading ? '…' : t('common.save')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditFormula1RoomModal
